import { render, staticRenderFns } from "./SaleOrderViewItem.vue?vue&type=template&id=0cb69b14&scoped=true&"
import script from "./SaleOrderViewItem.vue?vue&type=script&lang=js&"
export * from "./SaleOrderViewItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderViewItem.vue?vue&type=style&index=0&id=0cb69b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb69b14",
  null
  
)

export default component.exports